<template>

    <section id="recursos" class="d-flex align-items-center recursos">

      <div class="container">

        <div class="section-title" data-aos="fade-up">
          <div class="row">
            <h1 data-aos="fade-up">O essencial para acelerar seu negócio digital</h1>
            <h5 class="mb-5" data-aos="fade-up" data-aos-delay="400">Oferecemos o que você precisa para escalar sua rotina de emissão fiscal.</h5>
          </div>

          <div class="row">
            <div class="col-md-5 d-flex align-items-stretch gap-5" data-aos="fade-left" data-aos-delay="300">
              <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
                <div class="image d-flex justify-content-center" data-aos="fade-right" data-aos-delay="150">
                  <img src="../assets/img/recursos-sigame-1.png" alt="" class="img-fluid" style="width: 380px;">
                </div>
              </div>
            </div>

            <div class="col-md-7 d-flex align-items-stretch pt-xl-0" data-aos="fade-left" data-aos-delay="300">
              <div class="content d-flex flex-column justify-content-center">

                  <div class="col-md-12 d-md-flex align-items-md-start">
                    <div class="count-box">
                      <div class="icon-box">
                        <i class="bi bi-bar-chart-line"></i>
                        <h3>Dashboard em tempo real</h3>
                      </div>
                      <div class="icon-box-desc pb-3">
                        <p class="description">Acompanhe em tempo real o controle fiscal de suas emissões através de um dashboard incrível. Veja em gráfico as estatísticas relevantes para seu negócio.</p>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 d-md-flex align-items-md-start">
                    <div class="count-box">
                      <div class="icon-box">
                        <i class="bi bi-robot"></i>
                        <h3>Emissão no piloto automático</h3>
                      </div>
                      <div class="icon-box-desc pb-3">
                        <p class="description">No Sigame simplificamos a burocracia, você configura a emissão de NFS-e no automático e reduz os procedimentos manuais que consomem muito tempo.</p>
                      </div>
                    </div>
                  </div>

              </div>
            </div>

          </div>

          <div class="row">

            <div class="col-md-7 d-flex align-items-stretch pt-xl-0" data-aos="fade-left" data-aos-delay="300">
              <div class="content d-flex flex-column justify-content-center">

                  <div class="col-md-12 d-md-flex align-items-md-start">
                    <div class="count-box">
                      <div class="icon-box">
                        <i class="bi bi-cloud-check"></i>
                        <h3>Notas fiscais em total segurança na nuvem</h3>
                      </div>
                      <div class="icon-box-desc pb-3">
                        <p class="description">Tenha a segurança que seu negócio precisa, nós mantemos suas notas fiscais salvas na nuvem para atender as exigências do fisco.</p>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 d-md-flex align-items-md-start ">
                    <div class="count-box">
                      <div class="icon-box">
                        <i class="bi bi-envelope-at"></i>
                        <h3>Envio de e-mail automático e manual</h3>
                      </div>
                      <div class="icon-box-desc pb-3">
                        <p class="description">Encaminhamos automáticamente conforme seu agendamento ou com um simples clique você agileza a tarefa de enviar segunda via para seus clientes.</p>
                      </div>
                    </div>
                  </div>

              </div>
            </div>

            <div class="col-md-5 align-items-stretch gap-5" data-aos="fade-left" data-aos-delay="300">
              <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
                <div class="image d-flex justify-content-end" data-aos="fade-right" data-aos-delay="150">
                  <img src="../assets/img/recursos-sigame-2.png" alt="" class="img-fluid" style="width: 380px;">
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>

  </section>

</template>

<script>
export default {
  name: 'RecursoComp'
}
</script>

<style scoped lang="scss">

.recursos {
  padding-top: 0;
  background-color: $plataforma-bg-color;
  padding: 5vh 1vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.recursos .content {
  padding: 0;
}

.recursos .content h3 {
  font-weight: 700;
  font-size: 34px;
  color: $color-base;
}

.recursos .content p {
  margin-bottom: 0;
}

.recursos .content .count-box {
  padding: 20px 0;
  width: 100%;
}

.recursos .content .count-box i {
  display: block;
  font-size: 360px;
  color: $a-color;
  float: left;
  line-height: 0;
}

.recursos .content .count-box span {
  font-size: 36px;
  line-height: 300px;
  display: block;
  font-weight: 700;
  color: $color-base;
  margin-left: 50px;
}

.recursos .content .count-box p {
  margin: 0px;
  margin: 0px 0px 0px 0px;
  padding: 15px 20px 20px 20px;
  font-size: 14px;
  color: $color-base;
}

.recursos .content .count-box a {
  font-weight: 600;
  display: block;
  margin-top: 20px;
  color: $color-base;
  font-size: 15px;
  transition: ease-in-out 0.3s;
}

.recursos .content .icon-box {
  display: flex;
  align-items: center;
  padding: 20px;
  background: $recurso-bg-color;
  transition: ease-in-out 0.3s;
  box-shadow: $recurso-icon-box-box-shadow;
}

.recursos .content .icon-box i {
  font-size: 32px;
  padding-right: 15px;
  line-height: 1;
}

.recursos .content .icon-box h3 {
  font-weight: 700;
  margin: 0;
  padding: 0;
  line-height: 1;
  font-size: 16px;
  text-align: left;
}

.recursos .content .icon-box h3 a {
  color: $color-base;
  transition: ease-in-out 0.3s;
}

.recursos .content .icon-box h3 a:hover {
  color: $a-color;
}

.recursos .content .icon-box:hover {
  background: $section-color-1;
}

.recursos .content .icon-box-desc {
  display: flex;
  align-items: center;
  padding: 0px;
  background: $recurso-bg-color;
  transition: ease-in-out 0.3s;
  box-shadow: $recurso-icon-box-box-shadow;
}

.recursos .content .icon-box-desc .description {
  font-size: 15px;
  line-height: 22px;
  margin-bottom: -15px;
  text-align: left;
}

@media (max-width: 1024px) {
  .recursos .image {
    text-align: center;
  }

  .recursos .image img {
    max-width: 70%;
  }
}

@media (max-width: 667px) {
  .recursos .image img {
    max-width: 100%;
  }

  .recursos .content .icon-box-desc .description {
    text-align: center;
  }
}

</style>
